import { useEffect, useRef, useState } from 'react';
import { getNextMonthTimestamp, getTimeForNextMonth } from './getTimeForNextMonth';

export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const targetRef = useRef(getNextMonthTimestamp());
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const tick = () => {
      const newTime = getTimeForNextMonth(targetRef.current);

      if (newTime.days <= 0 && newTime.hours <= 0 && newTime.minutes <= 0 && newTime.seconds <= 0) {
        setIsExpired(true);
      }
      setTimeLeft(newTime);
    };

    tick();

    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);

  return { timeLeft, isExpired };
};